import ProjectForm from '../../../features/admin/forms/ProjectForm';

const AdminProjectsCreate = () => {
  return (
    <ProjectForm />
  )
};
export default AdminProjectsCreate